module.exports = __webpack_public_path__ + "static/img/v2.f537c75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/v2.svg
// module id = L7rz
// module chunks = 0